import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'

import Axios from 'axios'
import Insights from './app/models/Insights'

Vue.config.productionTip = false

Insights.app.mode = "standard";//"standard" or "operations";
// Insights.app.mode = "operations";//"standard" or "operations";

let url = "https://data.csueastbay.edu/data/app.insights.toc.php";
url += (Insights.app.mode === 'operations') ? "?mode=operations" : "";

//Mount
new Vue({
	router,
	render: h => h(App)
}).$mount('#app');

//Get TOC and load
Axios.get(url)
	.then(response => {
		return response.data;
	})
	.then(data => {
		Insights.bootstrap(data);
	})
	.then(()=>{
		router.push(Insights.app.landingPath);
	})
	.catch(() => {
		//503: Unavailable (the TOC couldn't be served)
		router.push('/503');
	});